import { weijuClosing } from '@/mocks/weiju';
import Reveal from '@/components/base/Reveal';

export default function Closing() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 text-xs md:text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
              {weijuClosing.title}
            </div>
            <p className="mt-5 font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug">
              {weijuClosing.oneLiner}
            </p>
            {weijuClosing.paragraphs.map((p) => (
              <p key={p.slice(0, 10)} className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </Reveal>

        {/* 五句浓缩 */}
        <Reveal delay={100}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {weijuClosing.fivePoints.map((p) => (
              <div key={p.label} className="p-5 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="font-heading font-bold text-lg text-primary-600">{p.label}</div>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 网站定位 */}
        <Reveal delay={200}>
          <div className="mt-8 p-6 md:p-8 rounded-lg bg-foreground-950 text-center">
            <div className="text-xs font-semibold tracking-widest text-foreground-400 uppercase">{weijuClosing.positioningTitle}</div>
            <p className="mt-4 font-heading font-bold text-xl md:text-2xl text-background-50 leading-snug">
              {weijuClosing.positioningHighlight}
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed max-w-2xl mx-auto">
              {weijuClosing.positioningDesc}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}